import {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {
    calculateTimeDifference,
    convertDateToBirth,
    convertDateToMonthAndYear,
    convertDateToYear
} from 'Services/Date/Date';
import DocumentTemplate from '../DocumentTemplate';
import bg_dots from './Components/Assets/bg-dots.svg';
import bg_logo from './Components/Assets/bg-logo.svg';
import birthday from './Components/Assets/birthday.svg';
import education from './Components/Assets/education.svg';
import email from './Components/Assets/email.svg';
import location from './Components/Assets/location.svg';
import logo from './Components/Assets/logo.svg';
import phone from './Components/Assets/phone.svg';
import salary from './Components/Assets/salary.svg';
import styles from './TalentProposalDocument.module.sass';
import {getAccessTokenFromLocal} from 'Services/helpers';
import {API_URL} from 'Store/Shared/Middleware/API/Constants';

const convert = (param: any) => Array.isArray(param) ? param.join(", ") : param;

const TalentProposalDocument = ({children}) => {
    const params: any = useParams();
    const [data, setData] = useState<any>({
        full_name: '',
        current_job_title: '',
        current_function_group: '',
        description_short: '',
        description: '',
        date_of_birth: '',
        seniority: '',
        work_areas: '',
        job_titles: '',
        languages: '',
        driver_license: '',
        salary: '',
        notice_period: '',
        skills: [],
        hard_skills: [],
        soft_skills: [],
        educations: [],
        courses: [],
        experiences: []
    });

    const fetchRecord = async () => {
        fetch(`${API_URL}/apiv2/file_generator/talent_proposal/${params.entity_id}/file/${params.file_id}`, {
            headers: {
                Authorization: `Bearer ${getAccessTokenFromLocal()}`
            },
        })
            .then(r => r.json())
            .then(({data}: any) => {
                setData({
                    full_name: data?.static?.first_name + ' ' + data?.static?.last_name,
                    description_short: data?.static?.description_short,
                    description: data?.static?.description,
                    date_of_birth: convertDateToBirth(data?.static?.date_of_birth),
                    languages: convert(data?.static?.languages),
                    driver_license: convert(data?.static?.driver_license),
                    salary: convert(data?.static?.salary),
                    notice_period: convert(data?.static?.notice_period),
                    skills: data?.static?.skills || [],
                    soft_skills: data?.static?.soft_skills || [],
                    hard_skills: data?.static?.hard_skills || [],
                    work_areas: convert(data?.static?.work_areas),
                    education: data?.static?.educations,

                    current_job: data?.dynamic?.current_job,
                    job: data?.dynamic?.job,
                    educations: data?.dynamic?.education,
                    courses: data?.dynamic?.courses,
                    experiences: data?.dynamic?.experience,
                    projects: data?.dynamic?.projects
                });

                setTimeout(() => {
                    document.body.classList.add('ready');
                    document.body.style.backgroundColor = "white";
                }, 250);
            });
    }

    useEffect(() => {
        fetchRecord();
    }, []);

    // return <DocumentTemplate headerHeight={'133px'} footerHeight={'200px'}>
    return <DocumentTemplate headerHeight={'133px'} footerHeight={'115px'}>
        <div className={styles['page-contact']}>
            <div className={styles['page-contact-item']}><img src={phone} /> 076 - 203 19 36</div>
            <div className={styles['page-contact-item']}><img src={email} /> breda@growing-people.nl</div>
            <img src={bg_dots} className={styles['page-contact-bg']} />
        </div>
        
        <div className={styles['page-header']}>
            <div className={`${styles['header']}`}>
                <div className={styles['header__title']}>
                    { data.full_name }
                </div>
                <div className={styles['header__job']}>
                    { data.current_job?.[0]?.c_job_title }
                </div>
                <div className={`${styles['label']}`}>
                { data.current_job?.[0]?.c_sector } / { data.current_job?.[0]?.c_job_group }
                </div>
            </div>
            <div className={styles['divider']} />
        </div>

        <div className={styles['page-footer']}>
            <div className={styles['page-footer-paragraph']}>
                Op al onze aanbiedingen/talentvoorstellen, opdrachten en overeenkomsten zijn de algemene voorwaarden van Growing People van toepassing. De algemene voorwaarden kunt u vinden op www.growing-people.nl/algemene-voorwaarden.<br/><br/>Dit document is alleen bestemd voor de geadresseerde. Als u dit bericht onbedoeld heeft ontvangen, verzoeken wij u het te vernietigen en de afzender te informeren. Het is niet toegestaan om een document dat niet voor u bestemd is te vermenigvuldigen, dan wel te verspreiden.
            </div>
            <img src={logo} className={styles['page-footer-logo']} />
            <img src={bg_logo} className={styles['page-footer-logo-bg']} />
        </div>


        <div className={styles['frontpage-fix']}>
            <div className={`${styles['title']} ${styles['title--large']}`}>Talentvoorstel</div>
            <div className={`${styles['header']} ${styles['header--large']}`}>
                <div className={styles['header__title']}>
                    { data.full_name }
                </div>
                <div className={styles['header__job']}>
                    { data.current_job?.[0]?.c_job_title }
                </div>
                <div className={`${styles['label']} ${styles['label--large']}`}>
                    { data.current_job?.[0]?.c_sector } / { data.current_job?.[0]?.c_job_group }
                </div>
            </div>
        </div>

        <div className={styles['attributes']}>
            <div className={styles['attributes-item']}>
                <div className={styles['attributes-item-icon']}><img src={birthday} /></div>
                <div className={styles['attributes-item-content']}>{ data.date_of_birth }</div>
            </div>
            <div className={styles['attributes-item']}>
                <div className={styles['attributes-item-icon']}><img src={location} /></div>
                <div className={styles['attributes-item-content']}>{ data.work_areas }</div>
            </div>
            <div className={styles['attributes-item']}>
                <div className={styles['attributes-item-icon']}><img src={salary} /></div>
                <div className={styles['attributes-item-content']}>{ data.salary }</div>
            </div>
            <div className={styles['attributes-item']}>
                <div className={styles['attributes-item-icon']}><img src={education} /></div>
                <div className={styles['attributes-item-content']}>{ data.education?.join('/') }</div>
            </div>
            <div className={styles['attributes-fullwidth']}>
                Beschikbaarheid: dit talent heeft <span className={styles['highlighted']}>{data.notice_period?.toLowerCase()}</span> opzegtermijn.
            </div>
        </div>
        
        <div className={styles['paragraph']}>
            <div dangerouslySetInnerHTML={{__html: data.description_short + data.description}} />
        </div>

        <div className={styles['divider']} />
        
        <div className={styles['section']}>
            <div className={styles['section-title']}>Zoekt een nieuwe uitdaging als...</div>
            <div className={styles['section-content']}>
                {
                    data.job?.map((i, idx) => {
                        return <>
                            { idx != 0 && <div className={`${styles['paragraph']} ${styles['paragraph--small']}`}>of als...</div> }
                            <div className={`${styles['paragraph']} ${styles['paragraph--small']}`}><span className={styles['highlighted']}>{i?.c_seniority?.toString()} {i?.c_job_title?.toString().toLowerCase()}</span> in de sector <span className={styles['highlighted']}>{i?.c_sector?.toString().toLowerCase()}</span> met als specialisatie <span className={styles['highlighted']}>{i?.c_job_group?.toString().toLowerCase()}</span></div>
                        </>
                    })
                }
            </div>
        </div>

        {
            data?.skills?.length > 0 && <>
                <div className={styles['divider']} />
                <div className={styles['section']}>
                    <div className={styles['section-title']}>Opleidingen en cursussen</div>
                    <div className={styles['section-content']}>
                        <div className={styles['skills-list']}>
                            { data?.skills?.map((skill: any) => <div className={styles['skills-list-item']}>{ skill }</div>) }
                        </div>
                    </div>
                </div>
            </>
        }

        {
            data?.soft_skills?.length > 0 && <>
                <div className={styles['divider']} />
                <div className={styles['section']}>
                    <div className={styles['section-title']}>Soft skills</div>
                    <div className={styles['section-content']}>
                        <div className={styles['skills-list']}>
                            { data?.soft_skills?.map((skill: any) => <div className={styles['skills-list-item']}>{ skill }</div>) }
                        </div>
                    </div>
                </div>
            </>
        }

        {
            data?.hard_skills?.length > 0 && <>
                <div className={styles['divider']} />
                <div className={styles['section']}>
                    <div className={styles['section-title']}>Hard skills</div>
                    <div className={styles['section-content']}>
                        <div className={styles['skills-list']}>
                            { data?.hard_skills?.map((skill: any) => <div className={styles['skills-list-item']}>{ skill }</div>) }
                        </div>
                    </div>
                </div>
            </>
        }

        {
            data?.educations?.length > 0 && <>
                <div className={styles['divider']} />
                <div className={styles['section']}>
                    {/* <div className={styles['section-title']}>Opleidingen</div> */}
                    <div className={styles['section-content']}>
                        <div className={styles['table']}>
                            {
                                data?.educations?.map((education, idx) => <div className={styles['table__row']}>
                                    <div className={styles['table__row-header']}>
                                        <div className={styles['table__row-header-static']}>
                                            { convertDateToMonthAndYear(education?.start_date) } - { !education?.end_date ? 'Heden' : convertDateToMonthAndYear(education?.end_date) }
                                        </div>
                                        <div className={styles['table__row-header-value']}>
                                            { convertDateToMonthAndYear(education?.start_date) } - { !education?.end_date ? 'Heden' : convertDateToMonthAndYear(education?.end_date) }
                                        </div>
                                    </div>
                                    <div className={styles['table__row-content']}>
                                        {
                                            idx == 0 &&
                                            <div className={styles['section-title']}>
                                                <div className={styles['section-title-static']}>Opleidingen</div>
                                                <div className={styles['section-title-value']}>Opleidingen</div>
                                            </div>
                                        }
                                        <span className={styles['highlighted']}>{ education.education }</span> - { education.education_institute } { education?.achieved && <div className={`${styles['label']} ${styles['label--inline']} ${styles['label--margin']}`}>Behaald</div> }
                                    </div>
                                </div>)
                            }
                        </div>
                    </div>
                </div>
            </>
        }

        {
            data?.courses?.length > 0 && <>
                <div className={styles['divider']} />
                <div className={styles['section']}>
                    {/* <div className={styles['section-title']}>Cursussen</div> */}
                    <div className={styles['section-content']}>
                        <div className={styles['table']}>
                            {
                                data?.courses?.map((course, idx) => <div className={styles['table__row']}>
                                    <div className={styles['table__row-header']}>
                                        <div className={styles['table__row-header-static']}>
                                            { convertDateToYear(course?.date) }
                                        </div>
                                        <div className={styles['table__row-header-value']}>
                                            { convertDateToYear(course?.date) }
                                        </div>
                                    </div>
                                    <div className={styles['table__row-content']}>
                                        {
                                            idx == 0 &&
                                            <div className={styles['section-title']}>
                                                <div className={styles['section-title-static']}>Cursussen</div>
                                                <div className={styles['section-title-value']}>Cursussen</div>
                                            </div>
                                        }
                                        <span className={styles['highlighted']}>{ course?.course }</span>
                                        { course?.behaald && <div className={`${styles['label']} ${styles['label--inline']} ${styles['label--margin']}`}>Behaald</div> }
                                    </div>
                                </div>)
                            }
                        </div>
                    </div>
                </div>
            </>
        }

        <div className={styles['divider']} />

        <div className={`${styles['section']} ${styles['section--disabled-page-break']}`}>
            <div className={styles['section-content']}>
                {
                    data?.experiences?.map((experience, idx: number) =>
                        <div className={styles['row']}>
                            <div className={`${styles['row__header']} ${styles['experience__placeholder']}`} style={{opacity: 0}}>{ convertDateToMonthAndYear(experience?.experiences[experience?.experiences.length-1]?.start_date) } - { !experience?.experiences[0]?.end_date ? 'Heden' : convertDateToMonthAndYear(experience?.experiences[0]?.end_date) }</div>
                            <div className={styles['row__content']}>
                                <div className={styles['experience']} style={{pageBreakInside: 'avoid'}}>
                                    {
                                        idx == 0 &&
                                        <div className={styles['section-title']}>
                                            <div className={styles['section-title-static']}>Werkervaringen</div>
                                            <div className={styles['section-title-value']}>Werkervaringen</div>
                                        </div>
                                    }
                                    <div className={styles['experience__header']}>
                                        <div className={styles['experience__header-static']}>
                                            { convertDateToMonthAndYear(experience?.experiences[experience?.experiences.length-1]?.start_date) } - { !experience?.experiences[0]?.end_date ? 'Heden' : convertDateToMonthAndYear(experience?.experiences[0]?.end_date) }
                                        </div>
                                        <div className={styles['experience__header-value']}>
                                            { convertDateToMonthAndYear(experience?.experiences[experience?.experiences.length-1]?.start_date) } - { !experience?.experiences[0]?.end_date ? 'Heden' : convertDateToMonthAndYear(experience?.experiences[0]?.end_date) }
                                        </div>
                                    </div>
                                    <div className={styles['title']}>{ experience?.company }</div>
                                    <div className={styles['title-description']}>{ calculateTimeDifference(experience?.experiences[experience?.experiences.length-1]?.start_date, experience?.experiences[0]?.end_date) } in totaal werkzaam</div>
                                    <div className={`${styles['divider']} ${styles['divider--small']}`} />
                                    <div className={styles['title--subtitle']}>{ experience?.experiences[0].title }</div>
                                    <div className={styles['title-description']}>{ convertDateToMonthAndYear(experience?.experiences[0]?.start_date) } - { !experience?.experiences[0]?.end_date ? 'Heden' : convertDateToMonthAndYear(experience?.experiences[0]?.end_date) }</div>
                                    <div className={`${styles['paragraph']} ${styles['paragraph--small']}`} dangerouslySetInnerHTML={{__html: experience?.experiences[0].description}} />
                                </div>
                                {
                                    experience?.experiences?.filter((i, idx) => idx != 0).map((exp) => 
                                        <div className={styles['job']}>
                                            <div className={styles['title--subtitle']}>{ exp.title }</div>
                                            <div className={styles['title-description']}>{ convertDateToMonthAndYear(exp?.start_date) } - { !exp?.end_date ? 'Heden' : convertDateToMonthAndYear(exp?.end_date) }</div>
                                            <div className={`${styles['paragraph']} ${styles['paragraph--small']}`} dangerouslySetInnerHTML={{__html: exp.description}} />
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    )
                }
            </div>
        </div>

        {
            data?.projects?.length > 0 && <>
                <div className={styles['divider']} />
                <div className={styles['section']}>
                    {/* <div className={styles['section-title']}>Projecten</div> */}
                    <div className={styles['section-content']}>
                        <div className={styles['table']}>
                            {
                                data?.projects?.map((project, idx) => <div className={styles['table__row']}>
                                    <div className={styles['table__row-header']}>
                                        <div className={styles['table__row-header-static']}>
                                            {
                                                convertDateToYear(project?.start_date) !== convertDateToYear(project?.end_date)
                                                ? `${ convertDateToYear(project?.start_date) } - ${ project?.end_date ? convertDateToYear(project?.end_date) : 'Heden' }`
                                                : convertDateToYear(project?.start_date)
                                            }
                                        </div>
                                        <div className={styles['table__row-header-value']}>
                                            {
                                                convertDateToYear(project?.start_date) !== convertDateToYear(project?.end_date)
                                                ? `${ convertDateToYear(project?.start_date) } - ${ project?.end_date ? convertDateToYear(project?.end_date) : 'Heden' }`
                                                : convertDateToYear(project?.start_date)
                                            }
                                        </div>
                                    </div>
                                    <div className={styles['table__row-content']}>
                                        {
                                            idx == 0 &&
                                            <div className={styles['section-title']}>
                                                <div className={styles['section-title-static']}>Projecten</div>
                                                <div className={styles['section-title-value']}>Projecten</div>
                                            </div>
                                        }
                                        <span className={styles['highlighted']}>{ project?.project }</span>
                                    </div>
                                </div>)
                            }
                        </div>
                    </div>
                </div>
            </>
        }
    </DocumentTemplate>;
}

export default TalentProposalDocument;